
export enum DISPLAY_TO_SHOPFRONT {
    DISPLAY_READY = "DISPLAY_READY",
    DISPLAY_HEARTBEAT_RESPONSE = "DISPLAY_HEARTBEAT_RESPONSE",
}

export enum DISPLAY_FROM_SHOPFRONT {
    OPEN_DISPLAY = "OPEN_DISPLAY",
    DATA_CHANGE = "DATA_CHANGE",
    DISPLAY_DONE = "DISPLAY_DONE",
    DISPLAY_CLOSE = "DISPLAY_CLOSE",
    DISPLAY_HEARTBEAT_REQUEST = "DISPLAY_HEARTBEAT_REQUEST",
}
